import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import awsConfig from './aws-exports';

//handle the case where pinpoint id doesnt update when changing environments
if (
  _.has(awsConfig, ['aws_cloud_logic_custom', 0, 'endpoint']) &&
  _.get(awsConfig, ['aws_cloud_logic_custom', 0, 'endpoint'], '').search('production') === -1
) {
  awsConfig['aws_mobile_analytics_app_id'] = '25d77723fd404025bde4114789f99079'; //I hate that these are hard coded
} else {
  awsConfig['aws_mobile_analytics_app_id'] = 'b3ef0bfdcd524f52b5106aaf7baa1c1f'; //I hate that these are hard coded
}

Amplify.configure(awsConfig);
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
